import * as ActionName from '../action-names';

export default {
  kambiClientRendered() {
    return { type: ActionName.KAMBI_CLIENT_RENDERED };
  },

  setIsMobileLook(value){
    return { type: ActionName.MOBILE_LOOK, value: value };
  },

  setDebugMode(value){
    return { type: ActionName.DEBUG_MODE, value: value };
  },

  setNativeUXVersion(value){
    return { type: ActionName.SET_NATIVE_UX_VERSION, value };
  }
};
